import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const draftContract = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {
                customRender: 'operation',
            },
            width: 100
        },
        {
            title: '合同编号',
            dataIndex: 'draft.contract.contractNumber',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.contractNumber || []
        },
        {
            title: '合同名称',
            dataIndex: 'draft.contract.contractName',
            key: 'contractName',
            scopedSlots: {
                customRender: 'contractName'
            }
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy'
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime'
        },
        {
            title: '备注',
            dataIndex: 'draft.remark',
            key: 'remark'
        },
    ]
}
